import React from 'react'
import "../Footer/Footer.css"
import { NavLink } from "react-router-dom";
const Footer = () => {
    return (
        <div>
            <div className="main-footer">
                <div className="container">
                    <div className="row">
                    <div className="col">
                        <h5>Program Linear Dua Variabel</h5>
                            <ul className="list-unstyled">
                                <li>Aplikasi Media Pembelajaran yang menyenangkan</li>
                            </ul>
                        </div>
                        {/* <div className="col">
                            <h5>Renaldi Al Amin</h5>
                            <ul className="list-unstyled">
                                <li>Instagram : aal_dyy</li>
                                <li>Twitter : renaldi_alamin</li>
                            </ul>
                        </div> */}
                       
                        <div className="col">
                        <h5>Universitas Lambung Mangkurat</h5>
                            <ul className="list-unstyled">
                                <li>Pendidikan Ilmu Komputer</li>
                                <li>Banjarmasin</li>
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <p className="text-center col-sm">
                            &copy;{new Date().getFullYear()} <NavLink to="/guru" style={{textDecoration:'none',color:'white'}}> Program Linear</NavLink> | Renaldi Al Amin 
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Footer
